import { render, staticRenderFns } from "./SidebarEditor.vue?vue&type=template&id=09e9af8b&scoped=true&"
import script from "./SidebarEditor.vue?vue&type=script&lang=js&"
export * from "./SidebarEditor.vue?vue&type=script&lang=js&"
import style0 from "./SidebarEditor.vue?vue&type=style&index=0&id=09e9af8b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09e9af8b",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UIEditorTextEditor: require('/Users/pam/Documents/Projects/cmp/cmp/city-manager-platform/components/UI/Editor/TextEditor.vue').default})
